export default __webpack_public_path__ + "static/media/005.7c8cb632.png";